import React, {Fragment} from 'react';
import Select from './../Select';
import {get, set} from "../../../utils/dotutils";
import isEqual from 'lodash-es/isEqual';
import AddressControl from "../AddressControl";
import {AddressFormatter} from "../../../utils/formatters";
import TextArea from "../TextArea";
import TextInput from "../TextInput";
import {loadComponentById} from "../../../utils/components";
import Button from "../Button";
import classNames from 'classnames';
import {debounce} from "lodash-es";

class FurgeFutarControl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            linkShippingAddress: this.props.linkShippingAddress,
            linkContact: this.props.linkContact
        };
        this.loadContact = debounce((partner_id) => {
            this.loadContactRequest && this.loadContactRequest.abort();
            this.loadContactRequest = loadComponentById("partner", partner_id, ["name", "email", "telnum"]);
            this.loadContactRequest.then((customer) => {
                this.setFieldValue("contact", customer.name);
                this.setFieldValue("email", customer.email);
                this.setFieldValue("telnum", customer.telnum);
            });
        }, 300);
        this.initValues();
    }

    setFieldValue = (field, value) => {
        let oldValue = get(this.props.value, field);
        if (!isEqual(oldValue, value)) {
            const v = {...this.props.value};
            set(v, field, value);
            this.setState({
                ...this.state
            });
            this.props.saveChanges(this.props.name, v);
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.linkShippingAddress !== prevProps.linkShippingAddress || this.props.linkContact !== prevProps.linkContact) {
            this.setState({
                linkShippingAddress: this.props.linkShippingAddress,
                linkContact: this.props.linkContact
            });
        }
        if (this.state.linkShippingAddress !== prevState.linkShippingAddress || this.state.linkContact !== prevState.linkContact) {
            this.initValues();
        } else if (!isEqual(this.props.client, prevProps.client)) {
            this.initValues();
        } else if (this.props.autoFill !== prevProps.autoFill) {
            this.initValues();
        }
    }

    initValues = () => {
        if (this.getProps('').disabled) return;
        if (this.props.autoFill !== false) {
            if (this.props.client && this.props.client.values) {
                if ((!this.props.value || !AddressFormatter(this.props.value.pickupaddress)) && AddressFormatter((this.props.client.values.origin || this.props.client.values.source || {}).address)) {
                    this.setFieldValue("pickupaddress", (this.props.client.values.origin || this.props.client.values.source).address);
                }
                if (this.state.linkShippingAddress !== false) {
                    this.recalculateShippingAddress();
                } else {
                    if ((!this.props.value || !AddressFormatter(this.props.value.shippingaddress)) && AddressFormatter((this.props.client.values.destination || this.props.client.values.target || {}).address)) {
                        this.setFieldValue("shippingaddress", (this.props.client.values.destination || this.props.client.values.target).address);
                    } else if ((!this.props.value || !AddressFormatter(this.props.value.shippingaddress)) && AddressFormatter((this.props.client.values.customer || {}).address)) {
                        this.setFieldValue("shippingaddress", this.props.client.values.customer.address);
                    }
                }
                if (this.state.linkContact !== false) {
                    this.loadContact && this.loadContact.cancel();
                    const partner_id = this.props.client.values.customer instanceof Object ? this.props.client.values.customer.partner_id : this.props.client.values.customer;
                    if (partner_id) {
                        this.loadContact(partner_id);
                    }
                }
            }
        }
    }

    recalculateShippingAddress = () => {
        if (AddressFormatter((this.props.client.values.destination || this.props.client.values.target || {}).address)) {
            if (AddressFormatter(this.props.value.shippingaddress) !== AddressFormatter((this.props.client.values.destination || this.props.client.values.target || {}).address)) {
                this.setFieldValue("shippingaddress", (this.props.client.values.destination || this.props.client.values.target).address);
            }
        } else if (AddressFormatter((this.props.client.values.customer || {}).address)) {
            if (AddressFormatter(this.props.value.shippingaddress) !== AddressFormatter((this.props.client.values.customer || {}).address)) {
                this.setFieldValue("shippingaddress", this.props.client.values.customer.address);
            }
        }
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        const shippingAddressProps = this.getProps("shippingaddress");
        const contactProps = this.getProps("contact");
        const emailProps = this.getProps("email");
        const telnumProps = this.getProps("telnum");
        return {
            ...this.props.fields,
            status: <div className="col-md-12">
                <Select
                    objectValue={false}
                    optionname="FurgeFutarStatus"
                    storeType="local"
                    name="status"
                    value={ (this.props.value && this.props.value.status) || null }
                    label="Futárszolgálat státusz"
                    saveChanges={this.setFieldValue}
                    {...this.getProps("status")}
                    disabled={true}
                />
            </div>,
            contact: <div className="col-md-12">
                <TextInput
                    {...contactProps}
                    name="contact"
                    required={true}
                    label="Címzett"
                    value={this.props.value && this.props.value.contact}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || contactProps.disabled}
                />
            </div>,
            email: <div className="col-md-12">
                <TextInput
                    {...emailProps}
                    name="email"
                    required={true}
                    label="Email"
                    value={this.props.value && this.props.value.email}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || emailProps.disabled}
                />
            </div>,
            telnum: <div className="col-md-12">
                <TextInput
                    {...telnumProps}
                    name="telnum"
                    required={true}
                    label="Telefon"
                    value={this.props.value && this.props.value.telnum}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || telnumProps.disabled}
                />
            </div>,
            autoInfo: this.props.autoFill !== false && <div className="col-md-12">
                <label className="control-label">&nbsp;</label>
                <Button
                    icon={{lib: "fas", name: this.state.linkContact !== false ? "link" : "unlink"}}
                    block={true}
                    color={this.state.linkContact !== false ? "primary" : "default"}
                    tooltip={"Autómatikus kitöltés " + (this.state.linkContact !== false ? "bekapcsolva" : "kikapcsolva")}
                    onClick={() => {
                        this.setState({linkContact: !(this.state.linkContact !== false)});
                    }}
                />
            </div>,
            origin: <Fragment>
                <AddressControl
                    name="pickupaddress"
                    value={ (this.props.value && this.props.value.pickupaddress) || null }
                    label="Honnan"
                    extrafields={["country"]}
                    saveChanges={this.setFieldValue}
                    {...this.getProps("pickupaddress")}
                />
            </Fragment>,
            destination: <Fragment>
                <div className="col-md-12">
                    <div className="row">
                        <div className={classNames({"col-md-11": this.props.autoFill !== false, "col-md-12": this.props.autoFill === false})}>
                            <div className="row">
                                <AddressControl
                                    name="shippingaddress"
                                    value={(this.props.value && this.props.value.shippingaddress) || null}
                                    label="Hova"
                                    extrafields={["country"]}
                                    saveChanges={this.setFieldValue}
                                    {...shippingAddressProps}
                                    disabled={(this.props.autoFill !== false ? this.state.linkShippingAddress !== false : false) || shippingAddressProps.disabled}
                                />
                            </div>
                        </div>
                        {this.props.autoFill !== false && <div className="col-md-1">
                            <label className="control-label">&nbsp;</label>
                            <Button
                                icon={{lib: "fas", name: this.state.linkShippingAddress !== false ? "link" : "unlink"}}
                                block={true}
                                color={this.state.linkShippingAddress !== false ? "primary" : "default"}
                                tooltip={"Autómatikus kitöltés " + (this.state.linkShippingAddress !== false ? "bekapcsolva" : "kikapcsolva")}
                                onClick={() => {
                                    this.setState({linkShippingAddress: !(this.state.linkShippingAddress !== false)});
                                }}
                            />
                        </div>}
                    </div>
                </div>
            </Fragment>,
            request: <div className="col-md-12">
                <TextArea
                    name="request"
                    value={(this.props.value && this.props.value.request) || ''}
                    label="Megjegyzés a futárnak"
                    saveChanges={this.setFieldValue}
                    {...this.getProps("request")}
                />
            </div>
        }
    }

    getLayout = () => {
        const fields = this.getFields();
        return <Fragment>
            {
                Object.keys(this.props.value || {}).indexOf("status") !== -1
                &&
                fields.status
            }
            {fields.origin}
            {fields.destination}
            {fields.request}
        </Fragment>;
    }

    render() {
        return this.props.layout ? this.props.layout(this.getFields()) : this.getLayout();
    }

}

export default FurgeFutarControl;